import { AutogenModelSettlementMovementLookup, AutogenRowSettlementMovementLookup } from "./autogen/AutogenModelSettlementMovementLookup";

export class ModelSettlementMovementLookup extends AutogenModelSettlementMovementLookup<RowSettlementMovementLookup> {
	constructor() {
		super(RowSettlementMovementLookup);
	}
}

export class RowSettlementMovementLookup extends AutogenRowSettlementMovementLookup {
}